import { Action } from 'redux';
import { SagaIterator } from 'redux-saga';
import { put, select, takeLatest } from 'redux-saga/effects';

import { UpdateTotalUserCountForServerUserSpace } from '~src/bootstrap/redux/actions/AppActionTypes';
import { requestFailed } from '~src/bootstrap/redux/actions/RequestFailedAction';
import { Messages } from '~src/codegen/Localize';
import { spaceContentsUpdateTotalCount } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { ISelectFilterDefinitionOption } from '~src/spacesPlatform/services/FilterPanelService';

import { maxSiteRoleCountsForServerUserSpaceUpdate, maxSiteRoleForServerUserSpaceUpdate } from '../actions/MaxSiteRoleForServerUserSpaceActions';
import { selectMaxSiteRoleCountsForServerUserSpace, selectMaxSiteRoleForServerUserSpace } from '../selectors/MaxSiteRoleForServerUserSpaceSelectors';


export interface UpdateTotalUserCountForServerUserSpaceAction extends Action {
    maxSiteRole?: string;
    maxSiteRoleCounts?: ISelectFilterDefinitionOption<string>[];
}

export function updateTotalUserCountForServerUserSpace(maxSiteRole?: string, maxSiteRoleCounts?: ISelectFilterDefinitionOption<string>[]): UpdateTotalUserCountForServerUserSpaceAction {
    return {
      type: UpdateTotalUserCountForServerUserSpace,
      maxSiteRole,
      maxSiteRoleCounts
    };
}

export function* handleUpdateTotalUserCountForServerUserSpace(action: UpdateTotalUserCountForServerUserSpaceAction): SagaIterator {
    try {
        if (action.maxSiteRole) {
            yield put(maxSiteRoleForServerUserSpaceUpdate(action.maxSiteRole));
        }
        if (action.maxSiteRoleCounts) {
            yield put(maxSiteRoleCountsForServerUserSpaceUpdate(action.maxSiteRoleCounts));
        }

        const maxSiteRole: string = yield select(selectMaxSiteRoleForServerUserSpace);
        const maxSiteRoleCounts: ISelectFilterDefinitionOption<string>[] = yield select(selectMaxSiteRoleCountsForServerUserSpace);
        const totalCount = maxSiteRoleCounts.find(siteRole => siteRole.value === maxSiteRole).count;
        yield put(spaceContentsUpdateTotalCount(totalCount));
    } catch (e) {
      yield put(requestFailed(e, Messages.errorUnknown()));
    }
  }

export function* rootServerUsersSpaceSaga(): SagaIterator {
    yield takeLatest(UpdateTotalUserCountForServerUserSpace, handleUpdateTotalUserCountForServerUserSpace);
}